<script>
import { mapGetters } from 'vuex'
import Roles from '@/mixins/Roles'
export default {
    name: 'UserView',

    mixins: [Roles],

    computed: mapGetters({ car: 'car', languages: 'languages' }),

    watch: {
        $route: 'fetch',
    },

    mounted() {
        this.fetch()
    },

    methods: {
        fetch() {
            this.$store.dispatch('carsFetch', this.$route.params.car)
        },

        save() {
            this.$store.dispatch('carsModify', this.car)
        },

        addAttachment(file) {
            this.car.attachments.push(file)
            this.$store.dispatch('carsModify', this.car)
        },

        delAttachment(index) {
            this.car.attachments.splice(index, 1)
            this.$store.dispatch('carsModify', this.car)
        },
    },
}
</script>

<template lang="pug">
div(v-if="car && car.id")
    acrm-top-panel.p-3
        .row
            .col
                .row
                    .col-auto.flex-center-v.align-content-center.justify-content-center
                        acrm-avatar(large :name="car.type")
                    .col-auto.flex-center-v
                        acrm-heading(:level="2").mb-0 {{ car.type }}
                    .col-24.col-lg

            .col-auto
                .text-right
                    acrm-input-button-dropdown(variant="link" icon="more_horiz" no-handle large align-right)


    acrm-tabs(:key="`car-${car.id}`")
        acrm-tab(:name="$t('BASE.BASEDATA')" tabKey="base-data")
            acrm-panel
                .row
                    .col-md-12
                        acrm-hidden-input.mb-3(v-model="car.license" @save="save")
                            label {{ $t('CARS.LICENSE')}}
                            div {{ car.license }}
                            acrm-input-line.mb-1(slot="edit" :disabled="!hasRoleUpdate('car.fields.license')" v-model="car.license") {{ $t('CARS.LICENSE')}}
                        acrm-hidden-input.mb-3(v-model="car.color" @save="save")
                            label {{ $t('CARS.COLOR')}}
                            div {{ car.color }}
                            acrm-input-line.mb-1(slot="edit" :disabled="!hasRoleUpdate('car.fields.color')" v-model="car.color")
                        acrm-hidden-input.mb-3(v-model="car.year" @save="save")
                            label {{ $t('CARS.YEAR')}}
                            div {{ car.year }}
                            acrm-input-line.mb-1(slot="edit" type="number" :disabled="!hasRoleUpdate('car.fields.year')" v-model="car.year" required)

        acrm-tab(:name="$t('BASE.ATTACHMENTS')" tabKey="attachments" v-if="hasRoleView('car.fields.attachments')")
            acrm-panel
                template(v-if="hasRoleUpdate('car.fields.attachments')")
                    label {{ $t('BASE.UPLOAD_ATTACHMENTS')}}
                    div
                        acrm-upload(@input="addAttachment")

                template(v-if="car && car.attachments && car.attachments[0]")
                    label.mt-3 {{ $t('BASE.ADDED_ATTACHMENTS') }}
                    table.table.table-striped.table-hover()
                        thead
                            tr
                                th {{ $t('BASE.FILENAME') }}
                                th {{ $t('BASE.UPLOAD_DATE') }}
                                th &nbsp;
                        tbody
                            tr(v-for="(file, index) in car.attachments" :key="file.id")
                                td {{ file.filename }}
                                td {{ file.created_at | toDate }}
                                td.text-right
                                    a(:href="file.urls.download")
                                        acrm-input-button.d-inline-flex.btn-lg.p-0(variant="link" icon="file_download")
                                    acrm-input-button.d-inline-flex.btn-lg.p-0(variant="link" icon="close" @click="delAttachment(index)" v-if="hasRoleUpdate('car.fields.attachments')")

</template>
